<template>
  <div class="select">
     <div class="exam-result-wrap" >
          <!-- <div :class='{right:cur_data.answer_right,wrong:!cur_data.answer_right}' class="answer_result"  v-show="cur_data.answerShow"><i></i>{{cur_data.answer_right? '回答正确':'回答错误'}}</div> -->
          <div class="exam-cell" >
              <div class="cell-tit">
                  <span class="selet-type-tag">{{cur_data.chapter_content.quiz_type == 1 ? $t('singleChoice') : $t('multipleChoice') }}</span>
                  <audio-btn class="exam-audio"></audio-btn>
                  <p v-html="cur_data.chapter_content.dry[0].content"></p>
              </div>
              <!-- 图片查看 -->
              <div class="img-wrap" v-if="cur_data.file_path ? cur_data.file_path.length>0 : false">
                <div v-for="(item, index) in cur_data.file_path" :key="index" class="img-list" @click="lookBgImg(item)">
                    <img :src="item"/>
                    <!-- <img src="@/assets/img/picTest/1.jpg"/> -->
                    <img src="@/assets/img/h5/img_fd.png" class="enlargement"/>
                </div>
              </div>
              <div class="cell-con">
                <div class="option" v-for='(item,index) in cur_data.chapter_content.dry' :key="item.id">
                    <!-- 未提交 -->
                    <div class="option-cell" :class="{isChose:option.answerStatus==1}" v-show="!cur_data.answerShow" v-for="(option ,i) in item.option" :key="option.id" @click="selected(option,item)">
                        <span><i :class="cur_data.chapter_content.quiz_type == 1 ? '' : 'checkebox-i'"></i></span><span>{{option.index}}、{{option.content}}</span>
                    </div>
                    <!-- 已提交 -->
                    <div  class="option-cell" :class="{right:option.answerStatus==2,warning:option.answerStatus==3,chose_true:option.answerStatus==4,chose_false:option.answerStatus==5}"  v-show="cur_data.answerShow" v-for="(option ,i) in item.option" :key="i" >
                        <span><i :class="cur_data.chapter_content.quiz_type == 1 ? '' : 'checkebox-i'"></i></span><span>{{option.index}}、{{option.content}}</span>
                    </div>
                </div>
              </div>
          </div>
     </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" >
            <v-bg-img :imgSrc="imgActive" v-if="imgActive" @closeImg="closeImg"></v-bg-img>
        </transition>
  </div>
</template>

<script>
import vBgImg from 'components/H5/bgImg.vue'
import mixins from 'components/H5/mixins/compon.js'
import audioBtn from 'components/H5/audioBtn'

export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      submitState: true,
      imgActive: null
      //  answerShow:false, //未提交
      //  answer_right:false, //总答案对错
    }
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    }
  },
  created () {
    // debugger
    this.index2ABC(this.cur_data.chapter_content.dry[0].option)
    this.getChapterAnswer()
  },
  mounted () {
    this.$nextTick(() => {
      $('.minitest').css('height', 'auto')
      $('.minitest').animate({ scrollTop: 0 }, 50)
      if ($('#appH5R')) {
        $('#appH5R').animate({ scrollTop: 0 }, 50)
      }
    })
    this.$store.commit('setAudioSrc', this.cur_data.audio_path || null)
    this.$store.commit('setAutoPlayer', !this.cur_data.answerShow)
  },
  methods: {
    // answerStatus  0：没选中 1：选中 2：选对 3：选错  4：没有选的对 5：没有的错
    selected (options, item) {
      if (this.cur_data.chapter_content.quiz_type == 1) {
        // 单选
        item.option.forEach((e) => {
          this.$set(e, 'answerStatus', 0)
        })
        this.$set(options, 'answerStatus', 1)
      } else {
        // 多选
        if (options.answerStatus) {
          this.$set(options, 'answerStatus', 0)
        } else {
          this.$set(options, 'answerStatus', 1)
        }
      }
    },
    submit () {
      let canSubmit = false
      let optionData = this.cur_data.chapter_content.dry[0].option
      let right_arr = [] // 答案总结数组
      for (let i = 0; i < optionData.length; i++) {
        if (optionData[i].answerStatus == 1) {
          canSubmit = true
        }
        // 提交答案做对比
        // 单多选
        if (optionData[i].answer == 1) {
          if (optionData[i].answerStatus == 1) {
            this.$set(optionData[i], 'answerStatus', 2) // right_arr:1 选正确 0 选错误 2没选正确
            right_arr.push('2')
          } else {
            this.$set(optionData[i], 'answerStatus', 4)
            right_arr.push('4')
          }
        } else {
          if (optionData[i].answerStatus == 1) {
            this.$set(optionData[i], 'answerStatus', 3)
            right_arr.push('3')
          } else {
            this.$set(optionData[i], 'answerStatus', 5)
            right_arr.push('5')
          }
        }
      }
      if (canSubmit) {
        this.$set(this.cur_data, 'answerShow', true)
        this.setChaperAnswer(optionData)
      }
      if (right_arr.indexOf('3') === -1 && right_arr.indexOf('4') === -1) {
        this.cur_data.answer_right = true
      } else {
        this.cur_data.answer_right = false
      }
      if (!canSubmit) {
        this.$layer.msg(this.$t('finishedSubmit'))
      }

      // console.log(this.data)
    }
  },
  components: {
    vBgImg,
    audioBtn
  }
}
</script>

<style lang="less" scoped>
.select {
    font-size: .26rem;
    .exam-result-wrap {
    .exam-cell{
      width: 100%;
      min-height:1.9rem;
      background-color: #fff;
      color: #252631;
      box-sizing: border-box;
      padding: .3rem .5rem;
      .cell-tit {
        font-size: .28rem;
        .exam-audio{
          display: inline-block;
        }
        .selet-type-tag {
          display: inline-block;
          color: #005587;
          font-size: .24rem;
          vertical-align: top;
          &:nth-of-type(1){
            text-align: center;
            color: #005587;
            border-radius: 4px;
            border: .02rem solid #005587;
            position: relative;
            padding:.015rem .1rem;
            box-sizing: border-box;
            &:after {
              width: .1rem;
              height: .1rem;
              background: white;
              position: absolute;
              bottom: -.07rem;
              left: .2rem;
              content: "";
              z-index: 1;
              transform: rotate(45deg);
              border-right: .02rem solid #005587;
              border-bottom: .02rem solid #005587;
            }
          }
          &:nth-of-type(2){
            margin-left: .2rem;
          }
        }
       p {
           margin-top:.2rem;
       }
      }
      .img-wrap{
        margin-top: .3rem;
      }
      .cell-con {
        color: #252631;
        font-size:.28rem;
        // padding-top: .15rem;
        .mini-img{
          position: relative;
          width: 1.2rem;
          height: 1rem;
          display: inline-block;
          img {
            position: absolute;
            display: inline-block;
            width: 1.2rem;
            height: 1rem;
            margin: 0 .2rem .2rem 0;
          }
          .fd {
            position: absolute;
            width: 1.2rem;
            height: 1rem;
            left: 0;
            top: 0;
            margin: 0 .2rem .2rem 0;
            background: url('../../../assets/img/h5/img_fd.png') no-repeat center;
            -webkit-background-size:50%;
            background-size:50%;
          }

        }
        .big-img {
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index:10;
          background-color: rgba(0,0,0,.2);
          img {
            position: absolute;
            width: 100%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display:-webkit-box;
          -webkit-box-orient:vertical;
        }
        .option {
        //   border-top:1px solid #D9DDDE;
          padding: .1rem 0  .3rem;
          margin-top: .3rem;
          .option-cell {
            width: 100%;
            min-height:1rem;
            border:1px solid #D9DDDE;
            position: relative;
            margin-top: .2rem;
            border-radius:.05rem;
            box-sizing: border-box;
            span {
              display: inline-block;
              vertical-align: middle;
              width: 5rem;
              &:nth-of-type(2){
                color: #666;
                padding: .3rem 0 0.3rem .2rem;
                font-size:.26rem;
                min-height:1rem;
                border-left:1px solid #D9DDDE;
                box-sizing: border-box;
              }
              &:nth-of-type(1){
                text-align: center;
                font-weight: bold;
                width: 1rem;
                i {
                  display: inline-block;
                  width: .4rem;
                  height: .4rem;
                  border-radius:50%;
                  border:1px solid #D9DDDE;
                  position: absolute;
                  left: .3rem;
                  top: 50%;
                  margin-top: -.2rem;
                }
                .checkebox-i{
                  border-radius: .06rem;
                }
              }
            }
            &.right {
              border:3px solid rgba(74, 168, 84, 1);
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/true.png') no-repeat center;
                    background-size: .22rem;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid rgba(74, 168, 84, 1);
                }
              }
            }
            &.warning {
              border:3px solid #F75D5D;
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/false.png') no-repeat center;
                    background-size: .22rem;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid #F75D5D;
                }
              }
            }
            &.chose_true {
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/choose-true.png') no-repeat center;
                    background-size: .22rem;
                  }
                }
              }
            }
            &.chose_false {
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/unchoose-false.png') no-repeat center;
                    background-size: .22rem;
                  }
                }
              }
            }
            &.isChose {
              border:3px solid #005587;
              span {
                &:nth-of-type(1){
                  i {
                    background: url('../../../assets/img/h5/chose.png') no-repeat center / contain;
                    border:none;
                  }
                  .checkebox-i{
                    width: .44rem;
                    height: .44rem;
                    background: url('../../../assets/img/h5/choose_squ.png') no-repeat center / contain;
                    background-size: .44rem;
                  }
                }
                &:nth-of-type(2){
                  border-left:3px solid #005587;
                }
              }
            }
          }
        }
        .option_wd {
          .option_a {
            width: 100%;
            background:rgba(247,247,247,1);
            border:1px solid rgba(217,221,222,1);
            font-size:.2rem;
            color: #666;
            padding: .2rem;
            margin: .2rem 0;
          }
          .option_e {
            border:1px solid #005587;
            width: 100%;
            height:auto;
            position: relative;
            border-radius: 3px;
            padding: .2rem;
            background-color: #EEF5FC;
            &:after{
              content: '';
              position: absolute;
              left: .4rem;
              top: -.11rem;
              width: .2rem;
              height: .2rem;
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
              border:1px solid #005587;
              border-radius: 1px;
              background-color: #EEF5FC;
              border-right: none;
              border-bottom: none;
            }
            h6 {
              color: #005587;
              font-size:.24rem;
              font-weight: bold;
            }
          }
        }
        .option-e {
          margin-top: .3rem;
          font-size:.28rem;
          font-weight: bold;
          span {
            &.right {
              color: #252631;
            }
            &.false {
              color: #F75D5D;
            }

          }
          i {
            display: inline-block;
            &.false {
              color: #F75D5D;
            }
              &.right {
                color: #4AA854;
              }

            }
        }
        .unfold {
          color: #005587;
          font-size:.24rem;
          margin: .1rem;
          text-align: right;
          font-weight: bold;
          img {
            float: right;
            width: .1rem;
            height: .06rem;
            text-align: right;
            margin:.16rem 0 0 .1rem;
            transition: all 1s;
            &.up {
              transform: rotate(180deg);
            }
          }
        }

      }
    }
  }
}
</style>
